<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UT0SxB/tc-custom/9780062079084.jpg?1731212273393" alt="This image is the cover for the book Hunchback of Neiman Marcus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hunchback of Neiman Marcus
      </h1>
      <p class="bookDescription body article font2">
        <p>“Funny, fresh, and heartbreakingly poignant, this book had me laughing and crying at the same time.”<br/>—Meg Cabot, author of <i>The Princess Diaries</i> series and <i>Insatiable</i></p><p>“I read <i>The Hunchback of Neiman Marcus</i> and I saw the light and the mirror and fell under Sonya Sones’ spell.”<br/>— Jacquelyn Mitchard, author of <i>The Deep End of the Ocean</i></p><p>“Wallpaper a room with the pages of <i>The Hunchback of Neiman Marcus</i>. It will be your favorite place. The room you come back to again and again, year after year.”<br/>—Ilene Beckerman, author of <i>Love, Loss, and What I Wore</i></p><p>Celebrated YA novelist Sonya Sones makes a HUGE splash with her first adult novel, <i>The Hunchback of Neiman Marcus</i>, spinning a funny, fierce, and piercingly honest coming-of-middle-age story about falling apart and putting yourself back together. Nora Ephron’s <i>I Feel Bad About My Neck</i> meets Elizabeth Berg—boldly original and endlessly enthralling—<i>The Hunchback of Neiman Marcus </i>is a luminous, brilliantly told story of life, marriage, and parenthood that you will not soon forget.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sonya Sones
      </h2>
      
      <p class="authorDescription body article"><P>Sonya Sones has written seven novels in verse: <I>The </I><I>Opposite of Innocent</I>, <I>Stop Pretending: What Happened When My Big Sister Went Crazy</I>; <I>What My Mother Doesn&#8217;t Know</I> and its companion, <I>What My Girlfriend Doesn&#8217;t Know</I>; <I>One of Those Hideous Books Where the Mother Dies</I>; <I>To Be Perfectly Honest</I>; and <I>Saving Red</I>. Sonya&#8217;s books have received many honors, but she was especially thrilled when she learned that she was on the American Library Association&#8217;s list of the Most Frequently Challenged Authors of the 21st Century. She lives near the beach in California. You can visit her at www.sonyasones.com or write her at sonyasones@gmail.com. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ba199cee